import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpExpressionDefinitionSaveRequestFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionFactory } from "./ExpExpressionDefinition";
// @ts-ignore noUnusedLocals
import { ExpExpressionDefinitionSaveOptionsFactory } from "./ExpExpressionDefinitionSaveOptions";

/**
 * 
 * @export
 * @interface ExpExpressionDefinitionSaveRequest
 */

export class ExpExpressionDefinitionSaveRequestFactory {}
_ExpExpressionDefinitionSaveRequestFactory = ExpExpressionDefinitionSaveRequestFactory;
_defineProperty(ExpExpressionDefinitionSaveRequestFactory, "FromJSON", function (json) {
  return _ExpExpressionDefinitionSaveRequestFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpExpressionDefinitionSaveRequestFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'definition': ExpExpressionDefinitionFactory.FromJSON(json['definition']),
    'saveOptions': json['saveOptions'] === null || json['saveOptions'] === undefined ? json['saveOptions'] : ExpExpressionDefinitionSaveOptionsFactory.FromJSON(json['saveOptions'])
  };
});
_defineProperty(ExpExpressionDefinitionSaveRequestFactory, "ToJSON", function (value) {
  return _ExpExpressionDefinitionSaveRequestFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpExpressionDefinitionSaveRequestFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'definition': ExpExpressionDefinitionFactory.ToJSON(value.definition),
    'saveOptions': ExpExpressionDefinitionSaveOptionsFactory.ToJSON(value.saveOptions)
  };
});
//# sourceMappingURL=ExpExpressionDefinitionSaveRequest.js.map
